export const PopupSymbol = Symbol('popup')
